/**
 * The schema of one shared-recipe reference, on its own so `workspace.ts` can
 * read it without importing `shared-recipes.ts`.
 *
 * That file builds a room's state from `emptyWorkspace()`, so it imports
 * `workspace.ts`; if `workspace.ts` imported it back, whichever module loaded
 * first would see the other half-initialised, and a test importing
 * `shared-recipes.ts` directly would read `sharedRecipeRefSchema` before it
 * existed. A leaf module with no imports of its own breaks the cycle.
 * `shared-recipes.ts` re-exports everything here, so callers never see the
 * split. @see shared-recipes.ts for what a reference means.
 */

import { z } from 'zod';
import { documentIdSchema } from './common';

/** One shared recipe, as this workspace sees it. */
export const sharedRecipeRefSchema = z.strictObject({
  role: z.enum(['owner', 'editor']),
  /** `null` = the room's shared default; else a profile in *this* workspace. */
  equipmentOverrideId: documentIdSchema.nullable(),
  joinedAt: z.number().int().nonnegative(),
});
export type SharedRecipeRef = z.infer<typeof sharedRecipeRefSchema>;
